import { connect } from 'react-redux'

import MyProgressDashboard from './MyProgressDashboard'
import {
  getIdentitySprint,
  getIdentitySprintResult,
  getIdentityBadges,
  getIsSprintsActive,
  getSprintTitle,
  getUserSprint,
  isStageIsSelection,
  isFirstActionFinished,
  getIdentityActivitiesHistorySliced,
  getIdentityPendingGetHistory,
} from 'store/entities/identity/selectors'

const mapStateToProps = state => {
  const sprint = getIdentitySprint(state)
  const userSprint = getUserSprint(state)
  const sprintResult = getIdentitySprintResult(state)
  const isSprintsActive = getIsSprintsActive(state)
  const activities = getIdentityActivitiesHistorySliced(state)
  const activitiesSize = activities.size

  return {
    sprint,
    isShownSprintInformation: isSprintsActive && !!getSprintTitle(state),
    sprintResult,
    isSprintAchieved:
      isSprintsActive && userSprint.isFinished && (sprintResult.userGoalAchieved || sprintResult.orgGoalAchieved),
    badges: isSprintsActive && getIdentityBadges(state),
    showStats: !isStageIsSelection(state) && activitiesSize && isFirstActionFinished(state),
    pending: getIdentityPendingGetHistory(state),
  }
}

export default connect(mapStateToProps)(MyProgressDashboard)
